import PropTypes from "prop-types";

const propTypes = {
  shouldExclude: PropTypes.bool,
  containerClass: PropTypes.string,
};

function PromoExclusion({ shouldExclude, containerClass = "" }) {
  return (
    shouldExclude && (
      <div data-test-id="promo-exclusion" className={`flex text-sm mt-1 ${containerClass}`}>
        <div>Excluded from additional promos. </div>
        <a href="/content-pages/rtr-promo" className="underline font-medium ml-1">
          Details
        </a>
      </div>
    )
  );
}

PromoExclusion.propTypes = propTypes;
export default PromoExclusion;
